import PropTypes from "prop-types";
import React, { useState } from "react";
import NoPermission from "./Nip-Permit-Form/NoPermission";
import Storage from "../../../utils/storage";
import { connect } from "react-redux";
import { sendRequestForPermit } from "../../../redux/Actions/NipOnboardingActions";
import NoPermissionManager from "./Nip-Permit-Form/NoPermissionManager";
import NipPermit from "./Nip-Permit-Form/NipPermit";
import Approved from "./Nip-Doc-Upload/Approved";
import PublicKeys from "./PublicKeys";

const PermitForm = (props) => {
  const {
    goToNext,
    isSending,
    submitRequest,
    networkId,
    requestStatus,
    applicationId,
    application,
    docApproval,
    getAllApplications,
    ipApproval,
  } = props;

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let userType = user && user.type;
  const [showIp, setShowIp] = useState(false);

  const status = application && application.status;

  const submitRequestValues = () => {
    const networkManagerId = {
      application_id: applicationId,
      network_manager_id: networkId,
    };
    submitRequest(networkManagerId);
  };

  return (
    <>
      {docApproval && userType === "company" && (
        <div>
          {!requestStatus && !showIp ? (
            <div className="doc-upload">
              {docApproval && status === "approved" && (
                <Approved goToNext={() => setShowIp(true)} />
              )}
            </div>
          ) : (
            <div>
              {ipApproval ? (
                <PublicKeys
                  application={application}
                  getAllApplications={getAllApplications}
                />
              ) : (
                <div className="nip-permit-form">
                  <NoPermission
                    isSending={isSending}
                    submitRequest={submitRequestValues}
                    requestStatus={requestStatus}
                    getAllApplications={getAllApplications}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {docApproval && userType === "company_network_manager" && (
        <div className="nip-permit-form">
          {requestStatus ? (
            <NipPermit goToNext={goToNext} application={application} />
          ) : (
            !requestStatus && <NoPermissionManager />
          )}
        </div>
      )}
    </>
  );
};

PermitForm.propTypes = {
  application: PropTypes.shape({
    status: PropTypes.any,
  }),
  applicationId: PropTypes.any,
  docApproval: PropTypes.any,
  getAllApplications: PropTypes.any,
  goToNext: PropTypes.any,
  ipApproval: PropTypes.any,
  isSending: PropTypes.any,
  networkId: PropTypes.any,
  requestStatus: PropTypes.any,
  submitRequest: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isSending: state.nipOnboarding.isSubmittingRequest,
    sendSuccess: state.nipOnboarding.submitRequestSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  submitRequest: (values) => dispatch(sendRequestForPermit(values)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PermitForm);
